import {Box, Button, IconButton, Paper, Stack, Tooltip, Typography} from "@mui/material";
import {
    CloudDoneRounded,
    Instagram,
    LinkRounded,
    PlagiarismRounded,
    ReportProblemRounded,
    RuleFolderRounded,
    Telegram,
    Twitter,
    WhatsApp
} from "@mui/icons-material";
import Toasty from "../../../theme/components/Toasty";
import {downloadBlob, downloadFiles} from "../../../lib/services/drive";
import {LoadingButton} from "../../../theme/components/LoadingButton";
import {useState} from "react";
import InputFieldModal from "../../dashboard/drive/inputFieldModal";
import TransferModal from "../../dashboard/drive/transferModal";
import ProgressRing from "../../common/progressRing";
import ProgressButton from "../../common/progressButton";
import axios from "axios";

const Actions = ({files, linkAddress}) => {

    const [pending, setPending] = useState(false);
    const [reportModal, setReportModal] = useState(false);
    const [reportPending, setReportPending] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [downloadCompleted, setDownloadCompleted] = useState(false);
    const [downloadFailed, setDownloadFailed] = useState(false);
    const [downloadController, setDownloadController] = useState(new AbortController());

    const shareText = 'میلفا، برای مشاهده اشتراک گذاری روی لینک درج شده کلیک کنید.';
    const shareUrl = window?.location?.href;

    const handleDownloadZip = async () => {
        setPending('download');
        try {
            setDownloadFailed(false);
            setDownloadCompleted(false);
            setDownloadProgress(0);
            console.log(linkAddress);
            const {data} = await downloadFiles('Share', {linkAddress, fileIds: files.map(f => f.id), isZip: true}, {onProgress: (progress) => setDownloadProgress(progress), signal: downloadController.signal})
            if (!data) return Toasty.error("دانلود فایل با مشکل مواجه شد!");
            await downloadBlob(data, 'files.zip');
            setDownloadCompleted(true);
        } catch (err) {
            if (downloadController?.signal?.reason === "user canceled") {
                return setDownloadController(new AbortController());
            }
            setDownloadFailed(true);
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setPending(false);
    }
    const handleCancelDownload = () => {
        downloadController.abort('user canceled');
        setDownloadCompleted(false);
        setDownloadProgress(0);
        setPending(false);
    }

    // Fake Submit (there is no report service)
    const handleSubmitReport = async (description) => {
        setReportPending(true)
        const ms = Math.ceil(Math.random() * 3000 + 1000);
        await new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
        Toasty.success('گزارش شما با موفقیت ثبت شد، با تشکر');
        setReportPending(false);
        setReportModal(false);
    }
    const handleCopyLink = () => {
        navigator?.clipboard.writeText(shareUrl);
        Toasty.success('لینک با موفیت کپی شد')
    }

    return (
        <>
            <Paper sx={{ mt: 3, p: {xs: 2, lg: 2.5} }}>
                <Stack spacing={1.25}>
                    <Button disabled variant="contained" fullWidth sx={{ py: 1.7  }} startIcon={<CloudDoneRounded/>} disableElevation>ذخیره در درایو</Button>
                    <ProgressButton
                        downloading={pending === "download"}
                        progress={downloadProgress}
                        isCompleted={downloadCompleted}
                        isFailed={downloadFailed}
                        onClick={handleDownloadZip}
                        onCancel={handleCancelDownload}
                        variant="contained" color="success" fullWidth
                        sx={{ py: 1.7  }} startIcon={<RuleFolderRounded/>}
                        disableElevation>فشرده سازی و دانلود</ProgressButton>
                    <Button onClick={() => setReportModal(true)} variant="contained" color="error" fullWidth sx={{ py: 1.7  }} startIcon={<ReportProblemRounded/>} disableElevation>گزارش مشکل</Button>
                </Stack>
                <Box mt={4} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                    <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600} textAlign="center">اشتراک گذاری</Typography>
                    <Box mt={2} width={1} display="flex" alignItems="center" justifyContent="space-between">
                        <a href={`https://api.whatsapp.com/send?text=${shareText}%20${window.location.href}`}>
                            <Tooltip title="اشتراک گذاری از طریق واتساپ">
                                <IconButton sx={{ color: "#25D366" }}>
                                    <WhatsApp fontSize="large"/>
                                </IconButton>
                            </Tooltip>
                        </a>
                        <a href={`https://telegram.me/share/url?url=${window.location.href}&text=${shareText}`}>
                            <Tooltip title="اشتراک گذاری از طریق تلگرام">
                                <IconButton sx={{ color: "#2AABEE" }}>
                                    <Telegram fontSize="large"/>
                                </IconButton>
                            </Tooltip>
                        </a>
                        <a href={`https://twitter.com/intent/tweet?url=${window.location.href}&text=${shareText}`}>
                            <Tooltip title="اشتراک گذاری از طریق تویتر">
                                <IconButton sx={{color: "#00acee"}}>
                                    <Twitter fontSize="large"/>
                                </IconButton>
                            </Tooltip>
                        </a>
                        <Tooltip title="کپی لینک">
                            <IconButton onClick={handleCopyLink} sx={{ color: theme => theme.palette.grey.dark }}>
                                <LinkRounded fontSize="large" sx={{ transform: "rotateZ(-40deg)" }}/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Paper>


            {/* File Transfer Modal */}
            {/*<TransferModal*/}
            {/*    open={true}*/}
            {/*/>*/}

            {/* Report Problem */}
            <InputFieldModal
            open={reportModal}
            onClose={() => setReportModal(false)}
            title="گزارش مشکل"
            inputProps={{ label: "توضیحات", placeholder: "لطفا مشکل خود را شرح دهید", multiline: true, minRows: 5 }}
            onConfirm={handleSubmitReport}
            pending={reportPending}
            />
        </>
    )
}
export default Actions;